<template>
    

    <div class="main-content">
      <v-container>
        <!-- Campo de búsqueda -->
        <v-row>
          <v-col cols="12">
            <v-card color="surfice" class="pa-4" height="300px" variant="transparent" style="background-image: url('https://images.tcdn.com.br/img/img_prod/1330203/1719209108_red_bull.jpeg'); 
         background-size: cover;  /* Asegura que la imagen cubra el contenedor */
         background-position: center; /* Centra la imagen */
         background-repeat: no-repeat; /* Evita que la imagen se repita */
         height: 100%; /* Asegura que ocupe toda la altura del contenedor */
  ">
              <v-chip color="primary" variant="flat">
                <v-card-title class="text-white" style="font-size: 1rem;"> <!-- Aumenté el tamaño de la fuente -->
                  Redbull
                </v-card-title>
              </v-chip>



            </v-card>
            <v-card-text>
              <v-text-field v-model="searchQuery" append-inner-icon="mdi-magnify" density="compact"
                label="Buscar producto" variant="solo" hide-details class="search-field"></v-text-field>
            </v-card-text>
          </v-col>

          <v-col cols="12">

          </v-col>
        </v-row>

        <!-- Boton de filtros -->
        <v-row justify="start">
          <v-col cols="auto">
            <v-btn variant="tonal" color="blue-darken-2" class="rounded-lg px-4 py-2 text-white"
              @click="dialogFiltro = true">
              <v-icon class="mr-2">mdi-filter-variant</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Filtro de precios menor que y mayor que -->
        <v-dialog v-model="dialogFiltro" max-width="420">
          <v-card class="rounded-lg">
            <v-card-title class="bg-grey-darken-4 text-white">
              <v-icon class="mr-2">mdi-filter-cog</v-icon> Filtrar y ordenar
            </v-card-title>

            <v-card-text class="py-4">
              <v-switch v-model="sortByPrice" color="black">
                <template v-slot:label>
                  <v-icon small class="mr-1"></v-icon>
                  <div>Precio <strong> De menor a mayor</strong></div>

                </template>
              </v-switch>

              <v-select v-model="selectedBrand" :items="brands" label="Filtrar por Marca" clearable variant="outlined"
                color="primary" dense>
                <template v-slot:prepend-item>
                  <v-icon left>mdi-filter</v-icon>
                </template>
              </v-select>

            </v-card-text>

            <v-card-actions class="justify-end bg-orange-lighten-3">

              <v-btn color="black" variant="flat" class="rounded-lg px-4 text-white" @click="applyFilters">
                <v-icon class="mr-1">mdi-check</v-icon> Aplicar
              </v-btn>


            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Botón del carrito flotante -->
        <v-btn @click="openCart" color="green-accent-3" class="fixed-cart-btn text-white " elevation="4">
          <v-icon left>mdi-cart-outline</v-icon>
          Ver Canastas ({{ cart.length }})
        </v-btn>



        <!-- Productos -->
        <v-row dense>
          <v-col v-for="(product) in filteredProducts" :key="product.id" cols="6" sm="6" md="4" lg="3"
            class="d-flex justify-center">

            <v-card class="pa-4" variant="transparent" style="width: 240px;">
              <!-- Rango TOP -->
              <v-col cols="12" class="d-flex justify-start">

              </v-col>


              <!-- Botón de agregar con ícono de plus en la parte superior derecha -->
              <v-row>
                <v-col class="d-flex justify-end" cols="12">
                  <v-btn class="text-none text-subtitle-1 add-to-cart-btn" color="transparent" variant="outlined"
                    @click="addToCart(product)" :id="'add-btn-' + product.id" :style="{
                      position: 'absolute',
                      top: '5px', /* Ajuste de distancia desde el borde superior */
                      right: '10px', /* Ajuste de distancia desde el borde derecho */
                      width: '30px',
                      height: '30px',
                      borderRadius: '100%'
                    }">
                    <v-icon color="green-accent-3" size="40">mdi mdi-plus-thick</v-icon>
                  </v-btn>

                </v-col>
              </v-row>

              <!-- Imagen del producto -->
              <v-row class="d-flex justify-center">
                <v-col cols="9">
                  <v-img lazyloading :src="product.foto || 'default-image-url'" height="100px" class="rounded"></v-img>
                </v-col>
              </v-row>


              <div class="w-full text-center mt-2">
                <!-- Precio del producto -->
                <div class="text-base sm:text-lg md:text-xl font-semibold text-blue-700 shadow-sm">
                  ${{ product.price }}
                </div>

                <!-- Nombre del producto -->
                <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                  {{ product.nombre }}
                </div>
              </div>


            </v-card>


          </v-col>
        </v-row>

        <!-- Diálogo del carrito -->
        <v-dialog v-model="cartDialog" max-width="600" scrollable>
          <v-card>
            <v-card-title class="headline" style="background-color: #f1f1f1; padding: 16px;">
              <v-icon left color="primary">mdi-cart-outline</v-icon>
              <span>Mv Express</span>
            </v-card-title> <v-card-text>
              <v-alert v-if="cart.length === 0" type="info" color="blue-lighten-4" icon="mdi-emoticon-sad-outline"
                prominent>
                <strong>¡Tu carrito está vacío!</strong>
                Agrega productos para comenzar tu compra en MV APP.
              </v-alert>


              <!-- Mostrar productos si hay en el carrito -->
              <div v-if="cart.length > 0">
                <v-container class="pa-0">
                  <v-row v-for="(item, index) in cart" :key="index" class="align-center border-b pb-1">

                    <!-- Imagen del producto -->
                    <v-col cols="2" class="d-flex justify-center">
                      <img lazyloading :src="item.foto" class="w-10 h-10 object-contain rounded-md" alt="Producto" />
                    </v-col>
                    <!-- Información del producto -->
                    <v-col cols="5" class="text-caption">
                      <div class="text-caption font-weight-medium text-gray-600">
                        {{ item.nombre }}
                      </div>
                      <div class="text-grey text-truncate">{{ item.sku }}</div>
                      <div class="text-caption font-weight-bold text-blue-darken-4 shadow-sm">
                        ${{ item.price }}
                      </div>


                    </v-col>

                    <!-- Controles de cantidad -->
                    <v-col cols="5" class="d-flex justify-end align-center">

                      <!-- Botón para disminuir -->
                      <v-btn @click="item.quantity--" :disabled="item.quantity <= 1" density="compact" icon color="red">
                        <v-icon size="18">mdi-minus</v-icon>
                      </v-btn>

                      <!-- Cantidad -->
                      <span class="px-2 text-caption font-weight-bold">CJA {{ item.quantity }}</span>

                      <!-- Botón para aumentar -->
                      <v-btn @click="increaseQuantity(item)" density="compact" class="text-white" icon
                        color="green-accent-3">
                        <v-icon size="18">mdi-plus</v-icon>
                      </v-btn>

                      <!-- Botón para eliminar -->
                      <v-btn variant="transparent" @click="removeFromCart(index)" density="compact" icon color="grey">
                        <v-icon size="18">mdi-delete</v-icon>
                      </v-btn>

                    </v-col>

                  </v-row>
                </v-container>
              </div>
              <v-row class="mb-3">
                <!-- Columna para el botón Vaciar carrito a la izquierda -->
                <v-btn @click="emptyCart" class="ma-2" color="red" variant="transparent" style="text-transform: none;">
                  <v-icon icon="mdi-delete" color="red" start></v-icon>
                  Vaciar canasta
                </v-btn>
              </v-row>

              <!-- Sugerencias de productos -->
              <div v-if="suggestedItems.length > 0" class="mt-4">
                <v-card-subtitle class="text-center font-weight-bold text-black">
                  Comprado frecuentemente
                </v-card-subtitle>

                <v-row>

                  <v-col v-for="product in suggestedItems" :key="product.id" cols="6" sm="6" md="4" lg="3"
                    class="d-flex flex-column align-center" style="position: relative;">
                    <!-- Añadido position: relative -->

                    <!-- Imagen del producto -->
                    <v-img :src="product.foto" width="100" height="100" alt="Imagen del producto"
                      class="rounded"></v-img>

                    <!-- Nombre del producto -->
                    <div class="text-caption font-weight-medium text-gray-600">
                      {{ product.nombre }}
                    </div>

                    <!-- Precio -->
                    <span class="font-weight-bold">${{ product.price || 'N/A' }}</span>

                    <!-- Botón de agregar al carrito -->
                    <v-btn class="text-none text-subtitle-1 add-to-cart-btn" color="transparent" variant="outlined"
                      @click="addToCart(product)" :id="'add-btn-' + product.id" :style="{
                        position: 'absolute',
                        top: '15px', /* Ajuste de distancia desde el borde superior */
                        right: '10px', /* Ajuste de distancia desde el borde derecho */
                        width: '10px',
                        height: '10px',
                        borderRadius: '80%'
                      }">
                      <v-icon color="green-accent-3" size="40">mdi mdi-plus-thick</v-icon>
                    </v-btn>

                  </v-col>


                </v-row>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-card-subtitle class="text-center font-weight-bold text-black">
                Subtotal: ${{ calculateTotal() }}
              </v-card-subtitle>

              <v-card-actions>
                <!-- Botones para cerrar el diálogo o proceder con la compra -->

                <v-btn @click="checkout" class="text-none ms-4 text-white" color="green-accent-3" rounded="0"
                  variant="flat">
                  Ir a pagar
                </v-btn>
              </v-card-actions>
            </v-card-actions>

          </v-card>
        </v-dialog>

      

      </v-container>
    </div>
   
</template>

<script>
import axios from 'axios';

export default {
  name: 'ExpressMV',
  components: {},
  data() {
    return {
      searchQuery: '',
      products: [],
      cart: [],
      cartDialog: false,
      suggestedItems: [],
      sortByPrice: false,
      dialogFiltro: false,
      selectedBrands: [],  // Para múltiples valores
      selectedBrand: null,
      brands: [], // Aseguramos que las marcas estén vacías al inicio
    };
  },
  computed: {
    filteredProducts() {
      let products = this.products.filter((product) => {
        const matchesSearch = product.nombre
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesBrand = this.selectedBrand
          ? product.sublinea === this.selectedBrand
          : this.selectedBrands.length > 0
            ? this.selectedBrands.includes(product.sublinea)
            : true;

        return matchesSearch && matchesBrand;
      });
      if (this.sortByPrice) {
        products = products.sort((a, b) => a.price - b.price);
      }

      return products;
    },
  },
  methods: {
    increaseQuantity(item) {
      item.quantity++;

      // ✅ Activar vibración si el navegador lo soporta
      if (navigator.vibrate) {
        navigator.vibrate(100); // Vibra por 100ms
      }

      localStorage.setItem('cart', JSON.stringify(this.cart));
    },

    applyFilters() {

      this.dialogFiltro = false;
    },

    async fetchProducts() {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          console.error('No token found, please login again');
          return;
        }

        const response = await axios.get('https://mvexpress.mx/api/103-redbull-productos', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Setear las marcas
        this.brands = [
          ...new Set(response.data.map((product) => product.sublinea)),
        ];

        this.products = response.data.map(product => ({
          ...product,
          price: product.price || 0, // Usa directamente la propiedad `price`
        }));
      } catch (error) {
        console.error('Error fetching products:', error.message);
      }
    },

    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },

    addToCart(product) {
      const existingProduct = this.cart.find(item => item.sku === product.sku && item.id === product.id);
      if (existingProduct) {
        existingProduct.quantity++;
      } else {
        this.cart.push({ ...product, quantity: 1 });
      }
      localStorage.setItem('cart', JSON.stringify(this.cart));
      // ✅ Activar vibración al agregar
      if (navigator.vibrate) {
        navigator.vibrate(150);
      }
    },

    emptyCart() {

      this.cart = [];

    },
    removeFromCart(index) {
      this.cart.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(this.cart));
    },

    calculateTotal() {
      return this.cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
    },

    checkout() {
      console.log('Carrito al hacer checkout:', this.cart);

      const total = this.cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
      console.log('Total calculado:', total);

      this.cart = [];
      this.cartDialog = false;

      this.$router.push({
        path: '/metodo-pago',
        query: { total }
      });
    },
suggestedProducts() {
  const token = localStorage.getItem("token"); // o donde lo guardes

  axios
    .get("https://mvexpress.mx/api/productos/suggested-products", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (Array.isArray(res.data) && res.data.length > 0) {
        this.suggestedItems = res.data;
      } else {
        console.error("No se encontraron productos sugeridos.");
      }
    })
    .catch((err) => {
      console.error("Error fetching suggested products:", err);
    });
},
  },
  mounted() {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.replace('/'); // Redirige y borra el historial
    }

    this.fetchProducts(); // Llama a la API para obtener los productos cuando el componente se monta

    const saveCart = localStorage.getItem('cart');
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }
  }
};
</script>


<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.main-content {
  height: 100vh;
  /* Ocupa toda la pantalla */
  padding-bottom: 80px;
  /* Deja espacio para la bottom-navigation */
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}
.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom); /* respeta la zona segura del teléfono */
  z-index: 9999;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}

</style>